import { ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { TonConnectUIProvider } from "@tonconnect/ui-react"
import { getRuntimeConfig } from "@/shared/config"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Avoid request “hammering” when backend is down / CORS blocks.
      // TanStack defaults retrying; for Mini Apps this quickly becomes noisy.
      retry: (failureCount, error) => {
        // Network/CORS errors are usually TypeError("Failed to fetch")
        if (error instanceof TypeError) return false
        const msg = error instanceof Error ? error.message : String(error)
        if (/failed to fetch/i.test(msg) || /networkerror/i.test(msg))
          return false

        return failureCount < 1
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 30, // 30 seconds
    },
  },
})

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  const config = getRuntimeConfig()

  return (
    <TonConnectUIProvider manifestUrl={config.tonConnectManifestUrl}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TonConnectUIProvider>
  )
}
